import React from "react";
import { ReactComponent as RemoveSvg } from "../remove.svg";
import "./btn-clear.scss";

const BtnClear = ({ onClick }) => {
    return (
        <div className="btn-clear-wrap">
            <button className="btn-clear" type="button" onClick={onClick}>
                <RemoveSvg />
            </button>
        </div>
    );
};
export default BtnClear;
